import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
// import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';


const TermsOfUse = () => {

    return (
        <>
            <SEO title="Terms Of Use" />
            {/* <ColorSwitcher /> */}
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne 
                title="Terms Of Use"
                page="Terms Of Use"
                />
                <div className="section-padding privacy-policy-area">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="privacy-policy-content">
                                

<p><b>By using our website or services, you agree to the following Terms & Conditions:</b></p>

<h4>1. Services Offered</h4>
<p>Graphify Infotech provides digital marketing services and training programs. All services are subject to availability and client agreement.</p>

<h4>2. User Responsibilities</h4>
<p>• You agree not to misuse the site or services.<br/>
• You agree to provide accurate and complete information during inquiries or registration.</p>

<h4>3. Intellectual Property</h4>
<p>All content, including text, images, logos, and course materials, is the property of Graphify Infotech and may not be reproduced without permission.</p>

<h4>4. Payments and Refunds</h4>
<p>• All payments for services or training must be made in full before commencement.<br/>
• Refund policies vary by service or course and will be shared before enrollment.</p>

<h4>5. Limitation of Liability</h4>
<p>We are not liable for any direct, indirect, or incidental damages arising from the use of our services or website.</p>

<h4>6. Modifications</h4>
<p>We reserve the right to update these Terms & Conditions at any time. Continued use of the site implies acceptance of the updated terms.</p>

<h4>7. Governing Law</h4>
<p>These terms are governed by the laws of India. Any disputes will be handled under the jurisdiction of Coimbatore, Tamil Nadu.</p>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <CtaLayoutOne />
            <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default TermsOfUse;